import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Card,
  CardContent,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/table';
import { Badge } from '@art-of-hospitality-solutions-llc/ui-kit/components/badge';
import Breadcrumbs from '@Components/Breadcrumbs';
import Loader from '@Components/Loader';
import { useEvalSuites } from '@Hooks/useEvals';
import { Link } from 'react-router-dom';

export default function Evals() {
  const { data: suites, status } = useEvalSuites();

  return (
    <div className="w-full">
      <Breadcrumbs
        navList={[
          { name: 'AI', href: '/evals' },
          { name: 'Evals', href: '/evals' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Evals</Heading>
          <p>
            Evaluation suites for AI agents. Runs always execute destructive
            tools in <strong>dry-run</strong> mode — no real SMS / email / DB
            writes occur.
          </p>
        </div>
        <div className="flex justify-end">
          <Button asChild>
            <Link to="/evals/create">Create Suite</Link>
          </Button>
        </div>
      </div>
      <Card>
        <CardContent>
          {status === 'pending' ? (
            <Loader size="lg" />
          ) : !suites?.length ? (
            <div className="py-8 text-center text-sm text-zinc-500">
              No eval suites yet. Create one to start tracking agent behavior.
            </div>
          ) : (
            <Table className="w-full">
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Default Soul</TableHead>
                  <TableHead>Cases</TableHead>
                  <TableHead>Runs</TableHead>
                  <TableHead>Created</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {suites.map((suite) => (
                  <TableRow key={suite.id}>
                    <TableCell>
                      <Button variant="link" className="px-0!" asChild>
                        <Link to={`/evals/${suite.id}`}>{suite.name}</Link>
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Badge
                        variant={
                          suite.status === 'PUBLISHED' ? 'default' : 'outline'
                        }
                      >
                        {suite.status}
                      </Badge>
                    </TableCell>
                    <TableCell>
                      {suite.defaultSoul?.name ?? (
                        <span className="text-zinc-400">—</span>
                      )}
                    </TableCell>
                    <TableCell>{suite._count?.cases ?? 0}</TableCell>
                    <TableCell>{suite._count?.runs ?? 0}</TableCell>
                    <TableCell>
                      {new Date(suite.createdAt).toLocaleDateString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
